// www/src/pages/Home.js
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { API_BASE_URL } from '../config';
import { track } from '../lib/analytics';
import './Home.css';

const DAY_LABEL = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

function formatTime(t) {
  if (!t) return '';
  const [hStr, mStr] = t.split(':');
  let h = parseInt(hStr, 10);
  const m = parseInt(mStr || '0', 10);
  if (Number.isNaN(h)) return t;
  const suffix = h >= 12 ? 'PM' : 'AM';
  h = h % 12 || 12;
  return m === 0 ? `${h} ${suffix}` : `${h}:${String(m).padStart(2, '0')} ${suffix}`;
}

export default function Home() {
  const [page, setPage] = useState(null);
  const [info, setInfo] = useState(null);
  const location = useLocation();

  useEffect(() => {
    fetch(`${API_BASE_URL}/api/homepage`).then((r) => r.ok ? r.json() : null).then(setPage).catch(() => {});
    fetch(`${API_BASE_URL}/api/business-info`).then((r) => r.ok ? r.json() : null).then(setInfo).catch(() => {});
  }, []);

  if (!page) return <main className="home-main"><div className="home-loading">Loading...</div></main>;

  return (
    <main className="home-main">
      <section className={`home-hero${page.heroImage ? '' : ' home-hero-no-image'}`}>
        {page.heroImage && (
          <img className="home-hero-image" src={page.heroImage} alt="" />
        )}
        <div className="home-hero-inner">
          <h1 className="home-hero-title">{page.heroTitle}</h1>
          <p className="home-hero-sub">{page.heroSubtitle}</p>
          <div className="home-hero-ctas">
            <Link
              to="/book"
              className="home-btn home-btn-primary"
              onClick={() => track('BOOK_INTENT', location.pathname)}
            >
              Book Now
            </Link>
            <Link to={page.ctaButtonLink || '/services'} className="home-btn home-btn-outline">{page.ctaButtonText || 'View Services'}</Link>
            <Link to="/contact" className="home-btn home-btn-outline">Get in touch</Link>
          </div>
        </div>
      </section>

      {info && (
        <section className="home-quickinfo">
          <div>
            <div className="home-label">Hours</div>
            <table className="home-hours">
              <tbody>
                {[1,2,3,4,5,6,0].map((d) => {
                  const h = (info.hours || []).find((x) => x.dayOfWeek === d) || { isOpen: false };
                  const time = h.isOpen ? `${formatTime(h.openTime)}–${formatTime(h.closeTime)}` : 'Closed';
                  return (
                    <tr key={d}>
                      <td>{DAY_LABEL[d]}</td>
                      <td>{time}{h.note ? <span className="home-hours-note"> ({h.note})</span> : null}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div>
            <div className="home-label">Location</div>
            <div>
              {info.addressLine1 || '—'}
              {info.city && <><br/>{info.city}{info.state ? `, ${info.state}` : ''}</>}
            </div>
          </div>
          <div>
            <div className="home-label">Contact</div>
            <div>
              {info.phone && <>{info.phone}<br/></>}
              {info.email}
            </div>
          </div>
        </section>
      )}
    </main>
  );
}
